<app-header />
<div class="home-main">
  <div class="sidebar">
    <app-sidebar (headingEvent)="receiveHeading($event)" (toggleSidebarEvent)="receiveSidebarEvent($event)" />
  </div>
  <div class="main_content_1  " [ngClass]="toggle_sidebar ? 'main_content_2' : 'main_content_1'">
    <div>
      <div class="background pt-4 z-0 h-full w-full bg">
        <div class="relative min-h-[60vh] h-auto flex-col justify-center w-full px-2 lg:px-5 py-7 opacity-100">


          <!-- Title -->
          <div class="text-center mt-[5rem] py-3">
            <div class="mx-auto w-full lg:w-[60%] max-w-[300px] flex justify-center">

              <!-- Premium User Icon -->
              <ng-container *ngIf="isSignedIn && accountType === 'premium'">
                <div class="w-[95px] h-auto">
                  <img src="../../../assets/img/premium.png" alt="user type" class="w-full h-auto object-contain" />
                </div>
              </ng-container>

              <!-- Free User Icon -->
              <ng-container *ngIf="isSignedIn && accountType === 'free'">
                <div class="bg-white w-[35px] h-[35px] mb-[15px] rounded-[5px] flex items-center justify-center">
                  <img src="../../../assets/img/evaluation-version.png" alt="user type"
                    class="w-full h-full object-contain" />
                </div>
              </ng-container>

            </div>
            <img src="../../../assets/img/AgropatLogo3.png" alt="AgroPat Ultimate Discovery Suite"
              class="mx-auto w-[80%] lg:w-[400px] max-w-[300px] " />
          </div>

          <!-- Introductory Paragraph -->
          <p class="text-white text-[22px] lg:text-[18px] font-semibold text-center py-1 uppercase"
            style="margin-bottom: 80px; padding-bottom: 180px">
            PROVIDING SOLUTIONS IN CROP PROTECTION FIELD INCLUDING PESTICIDE,
            BIO-PESTICIDE, FERTILIZERS & GROWTH STIMULANTS.
          </p>

          <!-- Sign In / Sign Up Buttons or Search Bar -->
          <div class="w-full mt-4 lg:w-full mx-auto">
            <!-- When User is NOT Signed In -->
            <div *ngIf="!isSignedIn" class="text-center" style="
                border: 1px solid #fafff9;
                border-radius: 16px;
                position: relative;
                display: flex;
                margin-top: 60px;
                justify-content: center;
                height: 100px;
              ">
              <p class="text-white text-[18px] font-semibold py-2" style="
                  position: absolute;
                  margin-top: -20px;
                  background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
                  color: rgb(255 237 141);
                  border-radius: 20px;
                  padding: 6px 20px !important;
                  font-weight: 500;
                ">
                To unlock the search functionality, please
                <span class="highlight-text cursor-pointer" (click)="openSignInForm()">Sign In</span>
                or
                <span class="highlight-text cursor-pointer" (click)="openSignUpForm()">Sign Up</span>
              </p>
              <div class="flex justify-center gap-4 mt-4" style="position: absolute; bottom: -26px">
                <button type="button" class="sign-in-button px-6 py-2 text-black font-[200]" (click)="openSignInForm()"
                  style="font-weight: 450; font-family: system-ui; height: 50px">
                  Sign In
                </button>
                <button type="button" class="sign-up-button px-6 py-2 text-black rounded-lg" (click)="openSignUpForm()"
                  style="font-weight: 450; font-family: system-ui; height: 50px">
                  Sign Up
                </button>
              </div>
            </div>

            <!-- When User is Signed In -->

            <div *ngIf="isSignedIn"
              class="min-h-[40vh] lg:min-h-[45vh] w-full p-3 lg:p-8 bg-white border-8 border-gray-400 rounded-2xl shadow-md">
              <!-- Desktop View -->
              <!-- <button class="btn btn-primary" (click)="downloadPdf()">PDF</button> -->
              <div class="overflow-x-auto scroll py-2 px-4 sm:px-6 hidden sm:block">
                <div class="flex justify-center w-full">
                  <!-- Cylindrical Background -->
                  <div class="bg-[#f2f6ff] rounded-full px-2 py-2 flex gap-4">
                    <!-- Button 1 -->
                    <button [ngClass]="{
                        'bg-[#388e3c] text-white': selectedItem === 0,
                        'bg-transparent text-[#388e3c]': selectedItem !== 0
                      }" (click)="selectItem(0)"
                      class="px-6 py-2 rounded-full font-semibold text-sm leading-[17px] transition duration-200">
                      Simple & Dynamic Search
                    </button>

                    <!-- Button 2 -->
                    <button [ngClass]="{
                        'bg-[#388e3c] text-white': selectedItem === 1,
                        'bg-transparent text-[#388e3c]': selectedItem !== 1
                      }" (click)="selectItem(1)"
                      class="px-6 py-2 rounded-full font-semibold text-sm leading-[17px] transition duration-200">
                      Advance Search
                    </button>

                    <!-- Button 3 -->
                    <button [ngClass]="{
                        'bg-[#388e3c] text-white': selectedItem === 2,
                        'bg-transparent text-[#388e3c]': selectedItem !== 2
                      }" (click)="selectItem(2)"
                      class="px-6 py-2 rounded-full font-semibold text-sm leading-[17px] transition duration-200">
                      See All
                    </button>
                  </div>
                </div>
              </div>

              <!-- Mobile View -->
              <div class="py-2 block sm:hidden">
                <div class="flex flex-col">
                  <button (click)="selectItem(0)" [ngClass]="{
                      'bg-gradient-to-r from-[#388e3c] to-[#0f4363] text-yellow-300 hover:bg-[#388e3c] hover:text-white':
                        selectedItem === 0,
                      'border-[#388e3c] text-[#388e3c] hover:bg-[#388e3c] hover:text-white':
                        selectedItem !== 0
                    }"
                    class="mt-2 px-4 py-2 rounded-md border-2 font-bold text-[14px] leading-[17.07px] border-[#388e3c] text-[#388e3c] hover:bg-[#1B4D3E] hover:text-white transition duration-200 w-full shadow-md">
                    Simple Text Search
                  </button>

                  <button (click)="selectItem(1)" [ngClass]="{
                      'bg-gradient-to-r from-[#388e3c] to-[#0f4363] text-yellow-300 hover:bg-[#388e3c] hover:text-white':
                        selectedItem === 1,
                      'border-[#388e3c] text-[#388e3c] hover:bg-[#388e3c] hover:text-white':
                        selectedItem !== 1
                    }"
                    class="mt-2 px-4 py-2 rounded-md border-2 font-bold text-[14px] leading-[17.07px] border-[#388e3c] text-[#388e3c] hover:bg-[#1B4D3E] hover:text-white transition duration-200 w-full shadow-md">
                    Dynamic Search Filter
                  </button>

                  <button (click)="selectItem(2)" [ngClass]="{
                      'bg-gradient-to-r from-[#388e3c] to-[#0f4363] text-yellow-300 hover:bg-[#388e3c] hover:text-white':
                        selectedItem === 2,
                      'border-[#388e3c] text-[#388e3c] hover:bg-[#388e3c] hover:text-white':
                        selectedItem !== 2
                    }"
                    class="mt-2 px-4 py-2 rounded-md border-2 font-bold text-[14px] leading-[17.07px] border-[#388e3c] text-[#388e3c] hover:bg-[#1B4D3E] hover:text-white transition duration-200 w-full shadow-md">
                    Advanced Search
                  </button>
                </div>
              </div>

              <!-- Content Based on Selection -->
              <div class="hidden py-2 px-4 sm:px-6 sm:block">
                <ng-container *ngIf="selectedItem === 0">
                  <h1
                    class="text-[18px] text-center bg-[#2e7c46] border border-[#ccc] p-[10px] my-[20px] rounded-[5px] shadow-md text-[#ffed8d]">
                    SIMPLE SEARCH
                  </h1>
                  <app-simple-search></app-simple-search>
                  <h1
                    class="text-[18px] text-center bg-[#2e7c46] border border-[#ccc] p-[10px] my-[20px] rounded-[5px] shadow-md text-[#ffed8d]">
                    DYNAMIC SEARCH
                  </h1>

                  <app-dynamic-search></app-dynamic-search>
                </ng-container>
                <ng-container *ngIf="selectedItem === 1">
                  <app-advance-search></app-advance-search>
                </ng-container>

                <ng-container *ngIf="selectedItem === 2">
                  <h1
                    class="text-[18px] text-center bg-[#2e7c46] border border-[#ccc] p-[10px] my-[20px] rounded-[5px] shadow-md text-[#ffed8d]">
                    SIMPLE SEARCH
                  </h1>
                  <app-simple-search></app-simple-search>
                  <h1
                    class="text-[18px] text-center bg-[#2e7c46] border border-[#ccc] p-[10px] my-[20px] rounded-[5px] shadow-md text-[#ffed8d]">
                    DYNAMIC SEARCH
                  </h1>
                  <app-dynamic-search></app-dynamic-search>
                  <h1
                    class="text-[18px] text-center bg-[#2e7c46] border border-[#ccc] p-[10px] my-[20px] rounded-[5px] shadow-md text-[#ffed8d]">
                    ADVANCE SEARCH
                  </h1>
                  <app-advance-search></app-advance-search>
                </ng-container>
              </div>

              <div class="block sm:hidden">
                <ng-container *ngIf="selectedItem === 0">
                  <app-simple-search></app-simple-search>
                  <!-- <h1
                      style="
                        font-size: 18px;
                        text-align: center;
                        background-color: #2e7c46;
                        border: 1px solid #ccc;
                        padding: 10px;
                        margin: 20px 0;
                        border-radius: 5px;
                        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
                        color: rgb(255, 237, 141);
                      "
                    >
                      DYNAMIC SEARCH
                    </h1>
    
                    <app-dynamic-search
                      (receivedynamicsearchdata)="receivedynamicsearchdata($event)"
                    ></app-dynamic-search> -->
                </ng-container>

                <ng-container *ngIf="selectedItem === 1">
                  <app-dynamic-search></app-dynamic-search>
                </ng-container>

                <ng-container *ngIf="selectedItem === 2">
                  <app-advance-search></app-advance-search>
                </ng-container>
              </div>
            </div>

            <!-- This section is for when the user is not authorised , use the menthod to check whether the use is logged in or not -->

            <!-- <div>
            <h1
              class="text-center text-[20px] leading-[33px] font-bold text-white mt-2"
            >
              To unlock this search functionality, please
              <span
                data-bs-toggle="modal"
                data-bs-target="#sign-in"
                class="hover:cursor-pointer text-[#FFCD04] text-[20px] leading-[33px] font-bold"
                >Sign In</span
              >
              or
              <a
                href="https://agropat.chemrobotics.com/registration"
                target="_blank"
                class="text-[#FFCD04] hover:cursor-pointer text-[20px] leading-[33px] font-bold"
              >
                Sign Up
              </a>
              to gain access.
            </h1>
            <div class="h-32 flex justify-center items-center flex-wrap gap-4">
              <button
                data-bs-toggle="modal"
                data-bs-target="#sign-in"
                class="text-black font-semibold rounded-full text-[15px] leading-[18.29px] px-5 py-3 bg-[#FFCD04]"
              >
                Sign in
              </button>
              <a
                href="https://agropat.chemrobotics.com/registration"
                target="_blank"
                class="text-black font-semibold rounded-full text-[15px] leading-[18.29px] px-5 py-3 bg-white"
              >
                Sign up
              </a>
            </div>
    
          
          </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="home_about" style="background-color: #f8faff">
      <div class="home_about_inner">
        <div class="home_about_inner_box">
          <!-- <div class="home_about_inner_box_top">
            <span
              class="text_style_8 text-center"
              style="font-size: 55px; margin-top: 0"
              >About Us</span
            >
          </div> -->
          <div class="home_about_inner_box_content">
            <p class="text_style_5">About Us</p>
            <p class="text_style_9 text-center" style="margin-top: 20px">
              ChemRobotics® is a Business, Scientific & Innovation Intelligence tool
              for Generic and Discovery Agrochem, Pharmaceutical API & Specialty
              Chemical Industry including Battery Chemicals, Dyes, and LED Chemical
              etc. It offers a wide range of scientific data to professionals in
              these industries. ChemRobotics® provides to be invaluable to various
              teams involved in product development, including chemists, formulation
              scientists, biologists, and the registration team.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="home_agropat">
      <div class="home_agropat_heading">
        <span class="text_style_5">AgroPat Ultimate™ - Discovery Suite</span>
      </div>
      <div class="home_agropat_desc">
        <span class="text_black_1">A Crop Protection Active Ingredient (AI) Database</span>
      </div>
      <div class="home_agropat_content">
        <div class="home_agropat_content_box">
          <div class="home_agropat_content_box_col">
            <div class="home_agropat_content_box_col_topl">
              <div class="home_agropat_content_box_col_topl_bg1" style="width: auto; height: auto">
                <img class="home_agropat_content_box_col_topl_bg1_img" src="../../../assets/img/flex1.png" />
              </div>
              <div class="home_agropat_content_box_col_topl_desc1" style="margin-right: 120px">
                <img class="home_agropat_content_box_col_topl_desc1_icon" src="../../../assets/icons/tick.png" />
                <span class="text_style_9">Agrochemical Innovation Intelligence
                </span>
              </div>
            </div>
            <div class="home_agropat_content_box_col_centerl">
              <div class="home_agropat_content_box_col_centerl_bg1" style="width: auto; height: 80px">
                <img class="home_agropat_content_box_col_centerl_bg1_img" src="../../../assets/img/flex3.png" />
              </div>
              <div class="home_agropat_content_box_col_centerl_desc1">
                <div class="home_agropat_content_box_col_centerl_desc1_left">
                  <img class="home_agropat_content_box_col_centerl_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_agropat_content_box_col_centerl_desc1_right">
                  <span class="text_style_9">
                    New or Existing Chemical Class Development Updates
                  </span>
                </div>
              </div>
            </div>
            <div class="home_agropat_content_box_col_bottoml">
              <div class="home_agropat_content_box_col_bottoml_bg1">
                <img class="home_agropat_content_box_col_bottoml_bg1_img" src="../../../assets/img/flex4.png" />
              </div>
              <div class="home_agropat_content_box_col_bottoml_desc1">
                <div class="home_agropat_content_box_col_bottoml_desc1_left">
                  <img class="home_agropat_content_box_col_bottoml_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_agropat_content_box_col_bottoml_desc1_right">
                  <span class="text_style_9">
                    New Mode of Acation (MoA) Candidates
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="home_agropat_content_box_col">
            <div class="home_agropat_content_box_col_topr">
              <div class="home_agropat_content_box_col_topr">
                <div class="home_agropat_content_box_col_topr_bg1" style="width: auto">
                  <img class="home_agropat_content_box_col_topr_bg1_img" src="../../../assets/img/flex2.png" />
                </div>
                <div class="home_agropat_content_box_col_topr_desc1">
                  <img class="home_agropat_content_box_col_topr_desc1_icon" src="../../../assets/icons/tick.png" />
                  <span class="text_style_9">
                    Early Identification of Advanced Agrochemical Candidates</span>
                </div>
              </div>
            </div>
            <div class="home_agropat_content_box_col_centerr">
              <div class="home_agropat_content_box_col_centerr_bg1">
                <img class="home_agropat_content_box_col_centerr_bg1_img" src="../../../assets/img/flex3.png" />
              </div>
              <div class="home_agropat_content_box_col_centerr_desc1">
                <div class="home_agropat_content_box_col_centerr_desc1_left">
                  <img class="home_agropat_content_box_col_centerr_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_agropat_content_box_col_centerr_desc1_right">
                  <span class="text_style_9">
                    Patent Watch for Active Ingredient Processes</span>
                </div>
              </div>
            </div>
            <div class="home_agropat_content_box_col_bottomr">
              <div class="home_agropat_content_box_col_bottomr_bg1">
                <img class="home_agropat_content_box_col_bottomr_bg1_img" src="../../../assets/img/flex5.png" />
              </div>
              <div class="home_agropat_content_box_col_bottomr_desc1">
                <div class="home_agropat_content_box_col_bottomr_desc1_left">
                  <img class="home_agropat_content_box_col_bottomr_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_agropat_content_box_col_bottomr_desc1_right">
                  <span class="text_style_9">
                    Innovator / Developer / Registration Information</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_agropat_bottom">
        <button class="header_background_transparent border-none">
          <a href="https://www.chemrobotics.com/agropat-ultimate/ "
            class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none home_agropat_bottom_btn"
            style="
              background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
              color: rgb(255 237 141);
            " target="_blank"
            onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
            onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';">
            <span class="button_blue_1_text text-yellow-300">View More</span>
            <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" />
          </a>
        </button>
      </div>
    </div>
    <div class="home_layout2">
      <div class="home_layout2_heading">
        <span class="text_style_5">AgroPat Ultimate™ - Discovery Suite</span>
      </div>
      <div class="home_layout2_desc">
        <span class="text_style_9">A Crop Protection Active Ingredient (AI) Database</span>
      </div>
      <div class="home_layout2_img">
        <img class="image_width3" src="../../../assets/img/agropat_bg.png" />
      </div>
      <div class="home_layout2_content">
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9"> Agrochemical Innovation Intelligence </span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">New or Existing Chemical Class Development Updates
            </span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">New Mode of Acation (MoA) Candidates</span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">
              Early Identification of Advanced Agrochemical Candidates</span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">
              Patent Watch for Active Ingredient Processes
            </span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">Innovator / Developer / Registration Information</span>
          </div>
        </div>
      </div>
      <div class="home_layout2_button">
        <button type="button" class="header_background_transparent border-none">
          <a class="button_blue_1 rounded-pill text_blue_4 text-yellow-300 text_decoration_none dis-flex-2"
            href="https://www.chemrobotics.com/agropat-ultimate/ " style="
              background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
              color: rgb(255, 237, 141);
            " target="_blank"
            onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
            onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"><span
              class="text-yellow-300">View More </span>
            <img class="button_blue_1_text_icon text-yellow-300" src="../../../assets/icons/arrow-right.png" /></a>
        </button>
      </div>
    </div>
    <div class="home_mrl">
      <div class="home_mrl_img">
        <img class="image_width1" src="../../../assets/img/global_agro_product.webp" />
      </div>
      <div class="home_mrl_content">
        <div class="home_mrl_content_box">
          <P class="text_style_5">Global Agro Product Directory</P>
          <P class="text_black_1_res text-justify">Global Agro Product Directory" is an Agrochemical product directory,
            where in all approved agrochemical the product can be tracked.</P>
          <div class="home_mrl_content_box_list">
            <div class="home_mrl_content_box_list_row text_style_9">
              <div class="home_mrl_content_box_list_row_item">
                <div><img src="../../../assets/icons/check-mark 1.png" /></div>
                <div class="p-l-10">
                  Approved products with all business as well as scientific
                  information
                </div>
              </div>
              <div class="home_mrl_content_box_list_row_item">
                <div><img src="../../../assets/icons/check-mark 1.png" /></div>
                <div class="p-l-10">
                  Technical and formulation supplier with their contact information
                </div>
              </div>
              <div class="home_mrl_content_box_list_row_item">
                <div><img src="../../../assets/icons/check-mark 1.png" /></div>
                <div class="p-l-10">
                  Label (English translated wherever), factsheet, monograph
                  documents
                </div>
              </div>
              <div class="home_mrl_content_box_list_row_item">
                <div><img src="../../../assets/icons/check-mark 1.png" /></div>
                <div class="p-l-10">
                  Product image as well as product trademark images
                </div>
              </div>
              <div class="home_mrl_content_box_list_row_item">
                <div><img src="../../../assets/icons/check-mark 1.png" /></div>
                <div class="p-l-10">
                  Registered company with their registration number
                </div>
              </div>
            </div>
          </div>
          <div class="home_mrl_content_box_button">
            <a type="button"
              class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none home_mrl_content_box_button_view"
              href="https://www.chemrobotics.com/agro-suite/global-agro-product-directory?access_key=MTA5Ng%3D%3D"
              target="_blank" style="
                background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
                color: rgb(255, 237, 141);
              "
              onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
              onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';">
              <span class="text-yellow-300"> View More </span>
              <img src="../../../assets/icons/arrow-right.png" style="margin-left: 8px" alt="Arrow Right" />
              <!-- Inline style for margin -->
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="home_layout1">
      <div class="home_layout1_heading">
        <span class="text_style_5">Global Agro Product Directory</span>
      </div>
      <div class="home_layout1_desc">
        <span class="text_style_9 text-justify">"Global Agro Product Directory" is an Agrochemical product directory,
          where in all approved agrochemical the product can be tracked.</span>
      </div>
      <div class="home_layout1_img">
        <img class="image_width2" src="../../../assets/img/global_agro_product.webp" />
      </div>
      <div class="home_layout1_content bg_yellow">
        <div class="home_layout1_content_list">
          <div class="home_layout1_content_list_row text_black_3_res">
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/check-mark 1.png" /></div>
              <div>
                Approved products with all business as well as scientific
                information
              </div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/check-mark 1.png" /></div>
              <div>
                Technical and formulation supplier with their contact information
              </div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/check-mark 1.png" /></div>
              <div>
                Label (English translated wherever), factsheet, monograph documents
              </div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/check-mark 1.png" /></div>
              <div>Product image as well as product trademark images</div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/check-mark 1.png" /></div>
              <div>Registered company with their registration number</div>
            </div>
          </div>
        </div>
        <div class="home_layout2_button">
          <button type="button" class="header_background_transparent border-none">
            <a class="button_blue_1 rounded-pill text_blue_4 text-yellow-300 text_decoration_none dis-flex-2"
              href="https://www.chemrobotics.com/agro-suite/global-agro-product-directory?access_key=MTA5Ng%3D%3D"
              target="_blank" style="
                background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
                color: rgb(255, 237, 141);
              "
              onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
              onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"><span>View
                More </span>
              <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></a>
          </button>
        </div>
      </div>
    </div>
    <div class="home_vetpat">
      <div class="home_vetpat_heading">
        <span class="text_style_5">PharmVetPat®</span>
      </div>
      <div class="home_vetpat_desc">
        <span class="text_black_1">(Pharmaceutical API & Specialty Chemical Database)</span>
      </div>
      <div class="home_vetpat_content">
        <div class="home_vetpat_content_box">
          <div class="home_vetpat_content_box_col">
            <div class="home_vetpat_content_box_col_topl">
              <div class="home_vetpat_content_box_col_topl_bg1" style="width: auto">
                <img class="home_vetpat_content_box_col_topl_bg1_img" src="../../../assets/img/flex1.png" />
              </div>
              <div class="home_vetpat_content_box_col_topl_desc1" style="margin-right: 50px">
                <img class="home_vetpat_content_box_col_topl_desc1_icon" src="../../../assets/icons/tick.png" />
                <span class="text_style_9">30000 Active Pharmaceutical Ingredients and their mixtures
                </span>
              </div>
            </div>
            <div class="home_vetpat_content_box_col_center1">
              <div class="home_vetpat_content_box_col_center1_bg1">
                <img class="home_vetpat_content_box_col_center1_bg1_img" src="../../../assets/img/flex3.png" />
              </div>
              <div class="home_vetpat_content_box_col_center1_desc1">
                <div class="home_vetpat_content_box_col_center1_desc1_left">
                  <img class="home_vetpat_content_box_col_center1_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_vetpat_content_box_col_center1_desc1_right">
                  <span class="text_style_9">Key Starting Material / Intermediate Information with CAS
                    No.</span>
                </div>
              </div>
            </div>
            <div class="home_vetpat_content_box_col_center2">
              <div class="home_vetpat_content_box_col_center2_bg1">
                <img class="home_vetpat_content_box_col_center2_bg1_img" src="../../../assets/img/flex3.png" />
              </div>
              <div class="home_vetpat_content_box_col_center2_desc1">
                <div class="home_vetpat_content_box_col_center2_desc1_left">
                  <img class="home_vetpat_content_box_col_center2_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_vetpat_content_box_col_center2_desc1_right">
                  <span class="text_style_9">2000 Synthesis routes and references</span>
                </div>
              </div>
            </div>
            <div class="home_vetpat_content_box_col_bottoml">
              <div class="home_vetpat_content_box_col_bottoml_bg1">
                <img class="home_vetpat_content_box_col_bottoml_bg1_img" src="../../../assets/img/flex4.png" />
              </div>
              <div class="home_vetpat_content_box_col_bottoml_desc1">
                <div class="home_vetpat_content_box_col_bottoml_desc1_left">
                  <img class="home_vetpat_content_box_col_bottoml_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_vetpat_content_box_col_bottoml_desc1_right">
                  <span class="text_style_9">Territory Coverage: USA, Europe, India, Japan, Brazil</span>
                </div>
              </div>
            </div>
          </div>
          <div class="home_vetpat_content_box_col">
            <div class="home_vetpat_content_box_col_topr">
              <div class="home_vetpat_content_box_col_topr">
                <div class="home_vetpat_content_box_col_topr_bg1" style="width: auto">
                  <img class="home_vetpat_content_box_col_topr_bg1_img" src="../../../assets/img/flex2.png" />
                </div>
                <div class="home_vetpat_content_box_col_topr_desc1">
                  <img class="home_vetpat_content_box_col_topr_desc1_icon" src="../../../assets/icons/tick.png" />
                  <span class="text_style_9">Physicochemical properties with more than 30 properties</span>
                </div>
              </div>
            </div>
            <div class="home_agropat_content_box_col_centerr">
              <div class="home_agropat_content_box_col_centerr_bg1">
                <img class="home_agropat_content_box_col_centerr_bg1_img" src="../../../assets/img/flex3.png" />
              </div>
              <div class="home_agropat_content_box_col_centerr_desc1">
                <div class="home_agropat_content_box_col_centerr_desc1_left">
                  <img class="home_agropat_content_box_col_centerr_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_agropat_content_box_col_centerr_desc1_right">
                  <span class="text_style_9">Product identification with CAS No. / Developmental code / EPA
                    Codes</span>
                </div>
              </div>
            </div>
            <div class="home_vetpat_content_box_col_bottomr">
              <div class="home_vetpat_content_box_col_bottomr_bg1" style="width: auto">
                <img class="home_vetpat_content_box_col_bottomr_bg1_img" src="../../../assets/img/flex5.png" />
              </div>
              <div class="home_vetpat_content_box_col_bottomr_desc1">
                <div class="home_vetpat_content_box_col_bottomr_desc1_left">
                  <img class="home_vetpat_content_box_col_bottomr_desc1_left_icon"
                    src="../../../assets/icons/tick.png" />
                </div>
                <div class="home_vetpat_content_box_col_bottomr_desc1_right">
                  <span class="text_style_9">Compound Patent / Innovator / Developer Information
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_vetpat_bottom">
        <a type="button" class="rounded-pill text_white_1 button_blue_1 dis-flex-2 text_decoration_none"
          href="https://chemroboticspharma.com/pharmVetPat  " target="_blank" style="
            background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
            color: rgb(255, 237, 141);
          "
          onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
          onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"><span
            class="button_blue_1_text text-yellow-300">View More </span>
          <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></a>
      </div>
    </div>
    <div class="home_layout2">
      <div class="home_layout2_heading">
        <span class="text_style_5">PharmVetPat®</span>
      </div>
      <div class="home_layout2_desc">
        <span class="text_style_9">(Pharmaceutical API & Specialty Chemical Database)</span>
      </div>
      <div class="home_layout2_img">
        <img class="image_width3" src="../../../assets/img/pharma_vetpat.png" />
      </div>
      <div class="home_layout2_content">
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">30000 Active Pharmaceutical Ingredients and their mixtures
            </span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">Key Starting Material / Intermediate Information with CAS No.</span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">2000 Synthesis routes and references</span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">Territory Coverage: USA, Europe, India, Japan, Brazil</span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">Physicochemical properties with more than 30 properties</span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">Product identification with CAS No. / Developmental code / EPA
              Codes</span>
          </div>
        </div>
        <div class="home_layout2_content_item">
          <div class="home_layout2_content_item_desc">
            <img class="home_layout2_content_item_desc_icon" src="../../../assets/icons/tick.png" />
            <span class="text_style_9">Compound Patent / Innovator / Developer Information
            </span>
          </div>
        </div>
      </div>
      <div class="home_layout2_button">
        <button class="header_background_transparent border-none">
          <a type="button"
            class="button_blue_1 rounded-pill text_blue_4 text-yellow-300 dis-flex-2 text_decoration_none"
            href="https://chemroboticspharma.com/pharmVetPat" target="_blank" style="
              background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
              color: rgb(255, 237, 141);
            "
            onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
            onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"><span>View
              More </span>
            <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></a>
        </button>
      </div>
    </div>
    <div class="home_techsupp">
      <div class="home_techsupp_content">
        <div class="home_techsupp_content_box">
          <p class="text_white_6_res">Indian Pesticide Database</p>
          <span class="text_white_5_res text-justify">IPD which offers pesticide product registration/approval
            information.</span>
          <div class="home_techsupp_content_box_list">
            <div class="home_techsupp_content_box_list_row text_white_4_res">
              <div class="home_techsupp_content_box_list_row_item">
                <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
                <div>
                  Product Registered under Section 9(3), Section 9(3B), Section 9(4)
                </div>
              </div>
              <div class="home_techsupp_content_box_list_row_item">
                <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
                <div>Registration information of bio-pesticides</div>
              </div>
              <div class="home_techsupp_content_box_list_row_item">
                <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
                <div>
                  Registration information for Export of existing/new Technical and
                  formulations
                </div>
              </div>
              <div class="home_techsupp_content_box_list_row_item">
                <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
                <div>
                  Endorsement information for transfer of Certificate of
                  Registration / address change / company name change
                </div>
              </div>
              <div class="home_techsupp_content_box_list_row_item">
                <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
                <div>
                  Inclusion information of new molecule/chemical in schedule of
                  Insecticides Act, 1968
                </div>
              </div>
              <!-- <div class="home_techsupp_content_box_list_row_item">
                <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
                <div>Product image as well as product trademark images</div>
              </div> -->
            </div>
          </div>
          <div class="home_techsupp_content_box_button">
            <a type="button" class="rounded-pill text_blue_4 button_white_1 dis-flex-2 text_decoration_none" style="
                background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
                color: rgb(255, 237, 141);
              " target="_blank"
              onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
              onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"
              href="https://ipd.chemrobotics.com/#/?access_key=MTA5Ng%3D%3D 
                        "><span>View More </span>
              <img class="home_techsupp_content_box_button_icon" src="../../../assets/icons/arrow-right.png" /></a>
          </div>
        </div>
      </div>
      <div class="home_techsupp_img">
        <img class="image_width1" src="../../../assets/img/ipd.png" />
      </div>
    </div>
    <div class="home_layout1">
      <div class="home_layout1_heading">
        <span class="text_style_5">Indian Pesticide Database</span>
      </div>
      <div class="home_layout1_desc">
        <span class="text_style_9 text-justify">IPD which offers pesticide product registration/approval
          information.</span>
      </div>
      <div class="home_layout1_img">
        <img class="image_width2" src="../../../assets/img/ipd_small.png" />
      </div>
      <div class="home_layout1_content bg_blue">
        <div class="home_layout1_content_list">
          <div class="home_layout1_content_list_row text_white_4_res">
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Product Registered under Section 9(3), Section 9(3B), Section 9(4)
              </div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>Registration information of bio-pesticides</div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Registration information for Export of existing/new Technical and
                formulations
              </div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Endorsement information for transfer of Certificate of Registration
                / address change / company name change
              </div>
            </div>
            <div class="home_layout1_content_list_row_item">
              <div><img src="../../../assets/icons/icon_tick_white.png" /></div>
              <div>
                Inclusion information of new molecule/chemical in schedule of
                Insecticides Act, 1968
              </div>
            </div>
          </div>
        </div>
        <div class="home_layout2_button">
          <button class="header_background_transparent border-none">
            <a type="button"
              class="button_blue_1 rounded-pill text_blue_4 text-yellow-300 dis-flex-2 text_decoration_none"
              href="https://ipd.chemrobotics.com/#/?access_key=MTA5Ng%3D%3D " style="
                background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
                color: rgb(255, 237, 141);
              "
              onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
              onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"><span>View
                More </span>
              <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png" /></a>
          </button>
        </div>
      </div>
    </div>

    <div class="home_services">
      <div class="row m-0">
        <div class="home_services_heading">
          <span class="text_style_5">Database</span>
        </div>
      </div>
      <div class="row justify-content-center mx-0">
        <div class="home_services_box">
          <div class="home_services_box_container">
            <ng-container *ngFor="let service of services">
              <div class="home_services_box_container_item">
                <div class="home_services_box_container_item_card">
                  <div class="home_services_box_container_item_card_row">
                    <div class="home_services_box_container_item_card_row_icon">
                      <img [src]="serviceLogoUrl + service.logo" alt="logo" *ngIf="service.logo"
                        class="home_services_box_container_item_card_row_icon_logo" />
                    </div>
                  </div>
                  <div class="home_services_box_container_item_card_row">
                    <p class="text_blue_1" [innerHTML]="service.name"></p>
                  </div>
                  <div class="home_services_box_container_item_card_row">
                    <div class="home_services_box_container_item_card_row_description">
                      <p class="text_style_9 text-left">
                        {{ service.description }}
                      </p>
                    </div>
                  </div>

                  <!-- Points for JARVIS Database -->
                  <div *ngIf="service.points" class="home_layout1_content_list_row">
                    <ng-container *ngFor="let point of service.points">
                      <div class="home_layout1_content_list_row_item">
                        <div>
                          <img [src]="'../../../assets/icons/' + point.icon" />
                        </div>
                        <div style="text-align: left">{{ point.text }}</div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- Button Below the Description -->
                  <div class="home_layout2_button">
                    <a type="button"
                      class="button_blue_1 rounded-pill text_blue_4 text-yellow-300 dis-flex-2 text_decoration_none"
                      [href]="service.buttonurl" target="_blank" style="
                        background: linear-gradient(
                          145.5deg,
                          #388e3c,
                          #0f4363 99.58%
                        );
                        color: rgb(255, 237, 141);
                      "
                      onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
                      onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';">
                      <span>View More</span>
                      <img class="button_blue_1_text_icon" src="../../../assets/icons/arrow-right.png"
                        alt="Arrow Right" />
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="home_info">
      <div class="home_info_left">
        <img class="home_info_left_img" src="../../../assets/img/infoo_bg.webp" />
      </div>
      <div class="home_info_right">
        <div class="home_info_right_box">
          <div class="home_info_right_box_ele1">
            <div class="home_info_right_box_ele1_top">
              <div class="home_info_right_box_ele1_top_icon icon_box">
                <svg width="53" height="38" viewBox="0 0 53 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2044_7357)">
                    <path
                      d="M17.1757 34.64C17.1475 34.922 17.1718 35.2166 17.2744 35.5086C17.5249 36.2125 18.1126 36.7858 18.8089 37.002C19.4559 37.207 20.0996 37.0705 20.2948 36.8577L21.6446 35.4058C22.0352 34.9873 22.1338 34.3183 21.9043 33.6692C21.3396 32.5844 20.5828 32.1929 19.6137 32.0176L17.1757 34.64Z"
                      fill="#388e3c" />
                    <path
                      d="M15.3702 27.3803L13.0112 29.9163C12.5319 30.439 12.3945 31.2423 12.6621 32.0121C12.9461 32.8254 13.624 33.4871 14.4353 33.7342C15.2032 33.9649 15.9738 33.7856 16.4564 33.2709L18.6406 30.9227C19.1231 30.4014 19.2573 29.602 18.9897 28.8322C18.7056 28.015 18.0238 27.3559 17.2164 27.1101C16.5721 26.9038 15.816 26.8959 15.3702 27.3803Z"
                      fill="#388e3c" />
                    <path
                      d="M10.6935 23.2059L8.5153 25.5501C8.03534 26.0688 7.90121 26.8748 8.16618 27.6472C8.45021 28.4579 9.12807 29.1195 9.93941 29.3667C10.706 29.6007 11.4845 29.4181 11.7271 29.1604L14.1453 26.5591C14.6279 26.0365 14.762 25.2331 14.4944 24.4647C14.2091 23.6487 13.5312 22.9897 12.7199 22.7452C11.9737 22.5013 11.1479 22.7182 10.6935 23.2059Z"
                      fill="#388e3c" />
                    <path
                      d="M6.43244 18.585L4.01817 21.1876C3.53558 21.7089 3.40145 22.5084 3.66905 23.2742C3.95045 24.0941 4.63226 24.7531 5.44359 25.0003C6.21022 25.2296 6.98736 25.0517 7.22734 24.7907L9.64819 22.1894V22.1868C10.1308 21.672 10.2649 20.8713 9.99731 20.1028C9.71722 19.283 9.03541 18.6239 8.22408 18.3794C7.60408 18.1652 6.85389 18.1283 6.43244 18.585Z"
                      fill="#388e3c" />
                    <path
                      d="M37.7759 3.06445C36.2144 3.93968 34.044 4.09653 31.9302 4.24877C30.3312 4.35817 28.6816 4.47417 27.4962 4.9131L20.9049 7.35094C20.8602 7.36873 20.8148 7.37928 20.7675 7.38587C20.4493 7.43595 20.1547 7.47879 19.8904 7.5157C18.2855 7.74241 18.1001 7.81161 17.9153 8.28811C17.747 8.72836 17.9318 9.36303 18.3881 9.90213C18.7602 10.345 20.2165 11.7277 23.2127 11.0166L26.9662 10.5197C29.0682 10.2481 30.7533 11.6216 32.0992 12.7301L42.1935 20.8246L42.2014 20.8207C44.1968 19.9837 46.2758 18.8949 48.0431 16.7609L37.7759 3.06445Z"
                      fill="#388e3c" />
                    <path
                      d="M23.8866 2.57252C23.2883 2.62788 22.6025 2.70367 21.8833 2.7788C17.9048 3.20455 15.699 3.37195 14.5767 3.16369L4.24829 16.6394C4.62832 16.9999 4.94325 17.3742 5.19704 17.7795C6.06031 16.8937 7.36475 16.5774 8.63501 16.9623C9.88159 17.3393 10.9224 18.3522 11.3576 19.609C11.5424 20.1409 11.6002 20.6866 11.5529 21.2092C12.0625 21.1374 12.6009 21.167 13.1309 21.3292C14.3742 21.7035 15.4189 22.7191 15.8509 23.9759C16.0382 24.5052 16.0974 25.0495 16.0527 25.5722C16.5623 25.5003 17.1007 25.5306 17.6307 25.6961C18.8713 26.073 19.9115 27.086 20.3467 28.3362C20.6202 29.1291 20.6308 29.945 20.4085 30.6765C20.5354 30.7009 20.6656 30.7319 20.7951 30.7728C21.9082 31.1188 22.8537 32.0355 23.2607 33.1658C23.6486 34.2598 23.4803 35.4092 22.8432 36.2343L24.6756 37.7034C25.124 38.0599 25.7775 38.0988 26.3877 37.8022C27.0491 37.4806 27.5488 36.8275 27.6961 36.0966C27.7579 35.7914 27.7375 35.4955 27.6678 35.2214L25.3436 33.3576C25.0313 33.1065 24.9761 32.6431 25.22 32.3215C25.4665 32.0025 25.9189 31.9432 26.2332 32.1943L29.0275 34.4391C29.3049 34.6618 30.0998 34.7211 30.829 34.3771C31.5956 34.01 32.1748 33.2534 32.3352 32.4092C32.4891 31.6111 32.2425 30.8373 31.6942 30.3945L29.1668 28.3672C28.8519 28.1161 28.7967 27.6515 29.0432 27.3338C29.2872 27.0109 29.7421 26.9516 30.0538 27.2066L33.7278 30.1519C34.2801 30.5922 35.0737 30.6528 35.8067 30.3101C36.5668 29.9456 37.146 29.1904 37.3104 28.3369C37.4643 27.5388 37.2177 26.7677 36.6634 26.3208L32.9881 23.3795C32.6732 23.1258 32.618 22.6624 32.8645 22.3382C33.1111 22.0205 33.5634 21.9652 33.879 22.2156C33.879 22.2156 39.4597 26.6886 39.4637 26.6886C39.7411 26.9074 40.5321 26.9694 41.2579 26.6214C42.0259 26.2622 42.6012 25.5069 42.7682 24.6561C42.9194 23.8566 42.6728 23.0803 42.1212 22.6413L31.1985 13.8792C29.9453 12.8491 28.6507 11.7821 27.1471 11.9845L23.4691 12.4656C20.9897 13.0627 18.6511 12.4722 17.2986 10.8693C16.4834 9.90382 16.2059 8.70962 16.5721 7.74938C17.0856 6.41743 18.0692 6.27969 19.6925 6.05034C19.9351 6.01936 20.1962 5.98114 20.4835 5.93566L27.007 3.52353C27.4311 3.36536 27.9005 3.25595 28.3864 3.15907C26.7092 2.50859 25.4935 2.4697 23.8866 2.57252Z"
                      fill="#FFCD04" />
                    <path
                      d="M9.70998 0.0178932C8.52192 -0.0723971 7.43707 0.825234 5.87555 2.86369L1.88201 8.07812C0.437522 9.95905 -0.103585 11.1289 0.0160768 12.1201C0.112069 12.9347 0.677503 13.7341 1.23834 14.1849L3.13254 15.7014L13.4188 2.28108L12.0874 1.21276C11.1722 0.481208 10.4227 0.0732537 9.70998 0.0178932Z"
                      fill="#FFCD04" />
                    <path
                      d="M42.6945 0.0044164C41.9818 0.049232 41.2257 0.448618 40.3033 1.16962L38.9574 2.2162L49.101 15.7459L50.412 14.7237C51.5462 13.8419 52.1248 13.053 52.2306 12.2391C52.3615 11.2505 51.8375 10.0715 50.416 8.16613L46.4875 2.90162C44.9569 0.842073 43.8859 -0.0720338 42.6945 0.0044164Z"
                      fill="#388e3c" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2044_7357">
                      <rect width="52.25" height="38" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <p class="home_info_right_box_ele1_heading text_blue_1">
              What We Offer
            </p>
            <p class="home_info_right_box_ele1_desc text_style_9 text-justify">
              We keep pace with industry trends and think as business people. We
              will be counselors, advisors and confidants to Agrochem,
              Pharmaceutical API & Specialty Chemical Industry including Battery
              Chemicals, Dyes, and LED Chemical etc. With our relationships, we can
              liaise with companies for identifying new business opportunities, and
              further R&D product development with regulatory and patent support.
            </p>
          </div>
          <div class="home_info_right_box_ele2">
            <div class="home_info_right_box_ele2_content">
              <div class="home_info_right_box_ele2_content_top">
                <div class="home_info_right_box_ele2_content_top_icon icon_box">
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2044_7398)">
                      <path
                        d="M17.7338 2.5332C7.93969 2.5332 0 10.4726 0 20.2664C0 30.0602 7.93969 37.9997 17.7338 37.9997C27.5279 37.9997 35.4677 30.0602 35.4677 20.2664C35.4677 17.8853 34.9973 15.6143 34.1461 13.5401L33.9879 13.6983C33.5744 14.1118 33.0305 14.3701 32.4484 14.428L30.5181 14.6204C31.2817 16.3468 31.7067 18.2567 31.7067 20.2659C31.7067 27.9826 25.4508 34.2383 17.7339 34.2383C10.0169 34.2383 3.7611 27.9826 3.7611 20.2659C3.7611 12.5493 10.0169 6.2938 17.7338 6.2938C19.7424 6.2938 21.6515 6.71841 23.3776 7.48145L23.5699 5.55287C23.628 4.97077 23.8872 4.42623 24.3007 4.01276L24.4592 3.85423C22.385 3.00345 20.1145 2.5332 17.7338 2.5332ZM17.7338 15.1998C18.1872 15.1998 18.6265 15.2597 19.0446 15.3714L15.9417 18.4748C14.9539 19.4626 14.9543 21.0671 15.9404 22.0561C16.4161 22.5332 17.0603 22.7997 17.7338 22.7997C18.4067 22.7997 19.0501 22.5333 19.526 22.0573L22.6286 18.9541C22.7405 19.3727 22.8005 19.8125 22.8005 20.2664C22.8005 23.0646 20.532 25.333 17.7337 25.333C14.9354 25.333 12.6669 23.0646 12.6669 20.2664C12.6671 17.4683 14.9355 15.1998 17.7338 15.1998ZM17.7338 8.82704C19.6771 8.82704 21.5069 9.31228 23.1097 10.1671L22.9836 11.432L21.0091 13.4067C20.0172 12.9323 18.9066 12.6665 17.7338 12.6665C13.5364 12.6665 10.1337 16.069 10.1337 20.2663C10.1337 24.4636 13.5364 27.8662 17.7338 27.8662C21.9313 27.8662 25.3339 24.4636 25.3339 20.2663C25.3339 19.0928 25.0678 17.9816 24.5928 16.9894L26.5678 15.0141L27.8319 14.8881C28.6877 16.4912 29.1732 18.3219 29.1732 20.2659C29.1732 26.5835 24.0516 31.705 17.7338 31.705C11.416 31.705 6.29435 26.5836 6.29435 20.2659C6.29435 13.9483 11.416 8.82704 17.7338 8.82704Z"
                        fill="#388e3c" />
                      <path
                        d="M24.199 12.0082L24.8302 5.67893C24.8601 5.38755 24.9908 5.11606 25.1963 4.90876L29.7343 0.370724C30.0854 0.0218948 30.6046 -0.0931444 31.0677 0.0786723C31.5309 0.249747 31.8558 0.675095 31.8931 1.16739L32.2517 5.74714L36.8345 6.10732C37.3238 6.14614 37.7496 6.46758 37.9214 6.93153C38.0932 7.39532 37.9774 7.91634 37.6301 8.26546L33.092 12.8032C32.8866 13.0106 32.614 13.1389 32.3227 13.1682L25.9918 13.7992L18.6301 21.1623C18.3836 21.4093 18.0586 21.5336 17.7337 21.5336C17.4088 21.5336 17.0838 21.4093 16.8373 21.1623C16.3443 20.6676 16.3443 19.8657 16.8373 19.3709L24.199 12.0082Z"
                        fill="#FFCD04" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2044_7398">
                        <rect width="38" height="38" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <p class="home_info_right_box_ele2_content_heading text_blue_1">
                Our Mission
              </p>
              <p class="home_info_right_box_ele2_content_desc text_style_9 text-justify">
                Achieve global excellence in IP services through consistent endeavor
                and attention to managing knowledge and information, and delivering
                consistently high standards of customer service.
              </p>
            </div>
          </div>
          <div class="home_info_right_box_ele1">
            <div class="home_info_right_box_ele1_top">
              <div class="home_info_right_box_ele1_top_icon icon_box">
                <svg width="53" height="38" viewBox="0 0 53 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2044_7357)">
                    <path
                      d="M17.1757 34.64C17.1475 34.922 17.1718 35.2166 17.2744 35.5086C17.5249 36.2125 18.1126 36.7858 18.8089 37.002C19.4559 37.207 20.0996 37.0705 20.2948 36.8577L21.6446 35.4058C22.0352 34.9873 22.1338 34.3183 21.9043 33.6692C21.3396 32.5844 20.5828 32.1929 19.6137 32.0176L17.1757 34.64Z"
                      fill="#388e3c" />
                    <path
                      d="M15.3702 27.3803L13.0112 29.9163C12.5319 30.439 12.3945 31.2423 12.6621 32.0121C12.9461 32.8254 13.624 33.4871 14.4353 33.7342C15.2032 33.9649 15.9738 33.7856 16.4564 33.2709L18.6406 30.9227C19.1231 30.4014 19.2573 29.602 18.9897 28.8322C18.7056 28.015 18.0238 27.3559 17.2164 27.1101C16.5721 26.9038 15.816 26.8959 15.3702 27.3803Z"
                      fill="#388e3c" />
                    <path
                      d="M10.6935 23.2059L8.5153 25.5501C8.03534 26.0688 7.90121 26.8748 8.16618 27.6472C8.45021 28.4579 9.12807 29.1195 9.93941 29.3667C10.706 29.6007 11.4845 29.4181 11.7271 29.1604L14.1453 26.5591C14.6279 26.0365 14.762 25.2331 14.4944 24.4647C14.2091 23.6487 13.5312 22.9897 12.7199 22.7452C11.9737 22.5013 11.1479 22.7182 10.6935 23.2059Z"
                      fill="#388e3c" />
                    <path
                      d="M6.43244 18.585L4.01817 21.1876C3.53558 21.7089 3.40145 22.5084 3.66905 23.2742C3.95045 24.0941 4.63226 24.7531 5.44359 25.0003C6.21022 25.2296 6.98736 25.0517 7.22734 24.7907L9.64819 22.1894V22.1868C10.1308 21.672 10.2649 20.8713 9.99731 20.1028C9.71722 19.283 9.03541 18.6239 8.22408 18.3794C7.60408 18.1652 6.85389 18.1283 6.43244 18.585Z"
                      fill="#388e3c" />
                    <path
                      d="M37.7759 3.06445C36.2144 3.93968 34.044 4.09653 31.9302 4.24877C30.3312 4.35817 28.6816 4.47417 27.4962 4.9131L20.9049 7.35094C20.8602 7.36873 20.8148 7.37928 20.7675 7.38587C20.4493 7.43595 20.1547 7.47879 19.8904 7.5157C18.2855 7.74241 18.1001 7.81161 17.9153 8.28811C17.747 8.72836 17.9318 9.36303 18.3881 9.90213C18.7602 10.345 20.2165 11.7277 23.2127 11.0166L26.9662 10.5197C29.0682 10.2481 30.7533 11.6216 32.0992 12.7301L42.1935 20.8246L42.2014 20.8207C44.1968 19.9837 46.2758 18.8949 48.0431 16.7609L37.7759 3.06445Z"
                      fill="#388e3c" />
                    <path
                      d="M23.8866 2.57252C23.2883 2.62788 22.6025 2.70367 21.8833 2.7788C17.9048 3.20455 15.699 3.37195 14.5767 3.16369L4.24829 16.6394C4.62832 16.9999 4.94325 17.3742 5.19704 17.7795C6.06031 16.8937 7.36475 16.5774 8.63501 16.9623C9.88159 17.3393 10.9224 18.3522 11.3576 19.609C11.5424 20.1409 11.6002 20.6866 11.5529 21.2092C12.0625 21.1374 12.6009 21.167 13.1309 21.3292C14.3742 21.7035 15.4189 22.7191 15.8509 23.9759C16.0382 24.5052 16.0974 25.0495 16.0527 25.5722C16.5623 25.5003 17.1007 25.5306 17.6307 25.6961C18.8713 26.073 19.9115 27.086 20.3467 28.3362C20.6202 29.1291 20.6308 29.945 20.4085 30.6765C20.5354 30.7009 20.6656 30.7319 20.7951 30.7728C21.9082 31.1188 22.8537 32.0355 23.2607 33.1658C23.6486 34.2598 23.4803 35.4092 22.8432 36.2343L24.6756 37.7034C25.124 38.0599 25.7775 38.0988 26.3877 37.8022C27.0491 37.4806 27.5488 36.8275 27.6961 36.0966C27.7579 35.7914 27.7375 35.4955 27.6678 35.2214L25.3436 33.3576C25.0313 33.1065 24.9761 32.6431 25.22 32.3215C25.4665 32.0025 25.9189 31.9432 26.2332 32.1943L29.0275 34.4391C29.3049 34.6618 30.0998 34.7211 30.829 34.3771C31.5956 34.01 32.1748 33.2534 32.3352 32.4092C32.4891 31.6111 32.2425 30.8373 31.6942 30.3945L29.1668 28.3672C28.8519 28.1161 28.7967 27.6515 29.0432 27.3338C29.2872 27.0109 29.7421 26.9516 30.0538 27.2066L33.7278 30.1519C34.2801 30.5922 35.0737 30.6528 35.8067 30.3101C36.5668 29.9456 37.146 29.1904 37.3104 28.3369C37.4643 27.5388 37.2177 26.7677 36.6634 26.3208L32.9881 23.3795C32.6732 23.1258 32.618 22.6624 32.8645 22.3382C33.1111 22.0205 33.5634 21.9652 33.879 22.2156C33.879 22.2156 39.4597 26.6886 39.4637 26.6886C39.7411 26.9074 40.5321 26.9694 41.2579 26.6214C42.0259 26.2622 42.6012 25.5069 42.7682 24.6561C42.9194 23.8566 42.6728 23.0803 42.1212 22.6413L31.1985 13.8792C29.9453 12.8491 28.6507 11.7821 27.1471 11.9845L23.4691 12.4656C20.9897 13.0627 18.6511 12.4722 17.2986 10.8693C16.4834 9.90382 16.2059 8.70962 16.5721 7.74938C17.0856 6.41743 18.0692 6.27969 19.6925 6.05034C19.9351 6.01936 20.1962 5.98114 20.4835 5.93566L27.007 3.52353C27.4311 3.36536 27.9005 3.25595 28.3864 3.15907C26.7092 2.50859 25.4935 2.4697 23.8866 2.57252Z"
                      fill="#FFCD04" />
                    <path
                      d="M9.70998 0.0178932C8.52192 -0.0723971 7.43707 0.825234 5.87555 2.86369L1.88201 8.07812C0.437522 9.95905 -0.103585 11.1289 0.0160768 12.1201C0.112069 12.9347 0.677503 13.7341 1.23834 14.1849L3.13254 15.7014L13.4188 2.28108L12.0874 1.21276C11.1722 0.481208 10.4227 0.0732537 9.70998 0.0178932Z"
                      fill="#FFCD04" />
                    <path
                      d="M42.6945 0.0044164C41.9818 0.049232 41.2257 0.448618 40.3033 1.16962L38.9574 2.2162L49.101 15.7459L50.412 14.7237C51.5462 13.8419 52.1248 13.053 52.2306 12.2391C52.3615 11.2505 51.8375 10.0715 50.416 8.16613L46.4875 2.90162C44.9569 0.842073 43.8859 -0.0720338 42.6945 0.0044164Z"
                      fill="#388e3c" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2044_7357">
                      <rect width="52.25" height="38" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
            <p class="home_info_right_box_ele1_heading text_blue_1">Our Vision</p>
            <p class="home_info_right_box_ele1_desc text_style_9 text-justify">
              Ambition, dedication and willingness to be outstanding to achieve the
              highest professional standards that will help us in being pioneer in
              the field. These values are percolated throughout the organization and
              is infused across the firm.
            </p>
          </div>
          <div class="home_info_right_box_ele2">
            <div class="home_info_right_box_ele2_content">
              <div class="home_info_right_box_ele2_content_top">
                <div class="home_info_right_box_ele2_content_top_icon icon_box">
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2044_7398)">
                      <path
                        d="M17.7338 2.5332C7.93969 2.5332 0 10.4726 0 20.2664C0 30.0602 7.93969 37.9997 17.7338 37.9997C27.5279 37.9997 35.4677 30.0602 35.4677 20.2664C35.4677 17.8853 34.9973 15.6143 34.1461 13.5401L33.9879 13.6983C33.5744 14.1118 33.0305 14.3701 32.4484 14.428L30.5181 14.6204C31.2817 16.3468 31.7067 18.2567 31.7067 20.2659C31.7067 27.9826 25.4508 34.2383 17.7339 34.2383C10.0169 34.2383 3.7611 27.9826 3.7611 20.2659C3.7611 12.5493 10.0169 6.2938 17.7338 6.2938C19.7424 6.2938 21.6515 6.71841 23.3776 7.48145L23.5699 5.55287C23.628 4.97077 23.8872 4.42623 24.3007 4.01276L24.4592 3.85423C22.385 3.00345 20.1145 2.5332 17.7338 2.5332ZM17.7338 15.1998C18.1872 15.1998 18.6265 15.2597 19.0446 15.3714L15.9417 18.4748C14.9539 19.4626 14.9543 21.0671 15.9404 22.0561C16.4161 22.5332 17.0603 22.7997 17.7338 22.7997C18.4067 22.7997 19.0501 22.5333 19.526 22.0573L22.6286 18.9541C22.7405 19.3727 22.8005 19.8125 22.8005 20.2664C22.8005 23.0646 20.532 25.333 17.7337 25.333C14.9354 25.333 12.6669 23.0646 12.6669 20.2664C12.6671 17.4683 14.9355 15.1998 17.7338 15.1998ZM17.7338 8.82704C19.6771 8.82704 21.5069 9.31228 23.1097 10.1671L22.9836 11.432L21.0091 13.4067C20.0172 12.9323 18.9066 12.6665 17.7338 12.6665C13.5364 12.6665 10.1337 16.069 10.1337 20.2663C10.1337 24.4636 13.5364 27.8662 17.7338 27.8662C21.9313 27.8662 25.3339 24.4636 25.3339 20.2663C25.3339 19.0928 25.0678 17.9816 24.5928 16.9894L26.5678 15.0141L27.8319 14.8881C28.6877 16.4912 29.1732 18.3219 29.1732 20.2659C29.1732 26.5835 24.0516 31.705 17.7338 31.705C11.416 31.705 6.29435 26.5836 6.29435 20.2659C6.29435 13.9483 11.416 8.82704 17.7338 8.82704Z"
                        fill="#388e3c" />
                      <path
                        d="M24.199 12.0082L24.8302 5.67893C24.8601 5.38755 24.9908 5.11606 25.1963 4.90876L29.7343 0.370724C30.0854 0.0218948 30.6046 -0.0931444 31.0677 0.0786723C31.5309 0.249747 31.8558 0.675095 31.8931 1.16739L32.2517 5.74714L36.8345 6.10732C37.3238 6.14614 37.7496 6.46758 37.9214 6.93153C38.0932 7.39532 37.9774 7.91634 37.6301 8.26546L33.092 12.8032C32.8866 13.0106 32.614 13.1389 32.3227 13.1682L25.9918 13.7992L18.6301 21.1623C18.3836 21.4093 18.0586 21.5336 17.7337 21.5336C17.4088 21.5336 17.0838 21.4093 16.8373 21.1623C16.3443 20.6676 16.3443 19.8657 16.8373 19.3709L24.199 12.0082Z"
                        fill="#FFCD04" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2044_7398">
                        <rect width="38" height="38" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <p class="home_info_right_box_ele2_content_heading text_blue_1">
                What We Offer
              </p>
              <p class="home_info_right_box_ele2_content_desc text_style_9 text-justify">
                We keep pace with industry trends and think as business people. We
                will be counselors, advisors and confidants to Agrochemical,
                Pharmaceutical, Veterinary, Ayurvedic, Homeopathy, Perfumery,
                Chemical and other segments. With our relationships, we can liaise
                with Academics, Corporates, R&D, Government organizations and others
                to provide our customers access to a network of expertise.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="news-container">
        <h2 class="news-title">News - Chemrocotics Times</h2>
        <div class="news-slider" #slider>
          <div class="news-card" *ngFor="let item of newsItems">
            <img [src]="item.image" alt="News Image" class="news-image" />
            <div class="news-content">
              <h3 class="news-headline">{{ item.title }}</h3>
              <p class="news-summary">{{ item.summary }}</p>
            </div>
          </div>
        </div>
        <button class="slider-button prev" (click)="prevSlide(slider)">
          &#8249;
        </button>
        <button class="slider-button next" (click)="nextSlide(slider)">
          &#8250;
        </button>
      </div> -->
  </div>
</div>

<app-footer />

<button class="back_to_top" (click)="scrollToTop()" *ngIf="isVisible">
  <img class="back_to_top_img" src="../../../assets/icons/back-to-top.png" />
</button>
<div class="modal fade modal-lg Video" id="VideoModel" tabindex="-1" role="dialog" aria-labelledby="VideoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog Video_model" role="document">
    <div class="modal-content Video_model_content position-relevant">
      <div class="modal-body Video_model_content_body">
        <button type="button" class="btn-close position-absolute" data-bs-dismiss="modal" aria-label="Close"></button>
        <video width="100%" height="100%" #aboutVideo controls>
          <source [src]="introVideo" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</div>